import { Link } from 'wouter';
import { routes } from '../lib/assessment/routes';

/**
 * Privacy Policy and Terms of Service links for the shared footer.
 *
 * Both point at the native v2 routes, which serve the migrated pages. There is
 * no configuration and no URL resolution: the destinations are internal app
 * routes, so they cannot be misconfigured.
 *
 * No consent language and no checkbox. The product records no affirmative
 * consent today, and wording that implied otherwise would assert something the
 * system cannot evidence.
 *
 * Styling follows the legacy footer, which renders these as plain links in one
 * evenly spaced row: no underline, and no separator character between them. An
 * earlier version underlined both and joined them with a middot; live
 * comparison against production showed neither.
 */
export function LegalLinks({ className }: { className?: string }) {
  return (
    <div
      className={`flex items-center justify-center gap-5 text-xs text-muted-foreground ${className ?? ''}`}
      data-testid="legal-links"
    >
      <Link
        href={routes.privacy}
        className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        data-testid="legal-link-privacy"
      >
        Privacy Policy
      </Link>
      <Link
        href={routes.terms}
        className="transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        data-testid="legal-link-terms"
      >
        Terms of Service
      </Link>
    </div>
  );
}
